<script lang="jsx">
import flow from '@/flows';
import { VIEWS } from '@/common/constants.js';
import { defineAsyncComponent } from 'vue';
import { isIAPRedirectUser } from '@/utils/iap';
import { modalIframeTrickyPatch } from '@/utils/modal-utils.js';

export default {
  components: {
    configView: defineAsyncComponent(() => import(/* webpackChunkName: "config" */ '@/views/config')),
    compoundView: defineAsyncComponent(() => import(/* webpackChunkName: "compound" */ '@/views/compound')),
    modalView: defineAsyncComponent(() => import(/* webpackChunkName: "modal" */ '@/views/modal/index.vue')),
    miniView: defineAsyncComponent(() => import(/* webpackChunkName: "mini" */ '@/views/mini/index.vue')),
    signView: defineAsyncComponent(() => import(/* webpackChunkName: "sign" */ '@/views/sign/index.vue')),
    ineligibleView: defineAsyncComponent(() => import(/* webpackChunkName: "ineligible" */ '@/views/ineligible')),
  },
  data() {
    return {
      VIEWS,
    };
  },
  computed: {
    view() {
      const view = flow.view();
      return view;
    },
  },
  created() {
    const isLoggedIn = !!(this.$context?.is?.loggedIn);
    if (isLoggedIn || isIAPRedirectUser) {
      this.$store.dispatch('initAccountInfo').catch(() => {});
    }
  },
  mounted() {
    if (this.$context?.is?.modal) {
      document.body.classList.add('opc-modal');
      modalIframeTrickyPatch();
    }
  },
  beforeUnmount() {
    if (this.$context?.is?.modal) {
      document.body.classList.remove('opc-modal');
    }
  },
  render() {
    const context = {...this.$props, ...this.$attrs};

    if (this.$context?.is.modal && !this.$context?.is.modal2Column) {
      return <modalView { ...context} viewModel={this.view} />;
    }

    if (this.view === VIEWS.MINI) {
      return <miniView { ...context} />;
    }

    if (this.view === VIEWS.SIGN) {
      return <signView { ...context} />;
    }

    if (this.view === VIEWS.INELIGIBLE) {
      return <ineligibleView { ...context} />;
    }

    if (this.view === VIEWS.CONFIG) {
      return <configView { ...context} />;
    }

    if (this.view === VIEWS.COMPOUND) {
      return <compoundView { ...context} />;
    }

    return null;
  }
};
</script>
